/* Oznake (badge) modula Fakture — jedan tok od menija do podtaba:

     FAKTURE                      = Izlazne + Ulazne
     ├─ Izlazne fakture           = Provera faktura + Pregled predračuna
     │   ├─ Provera faktura       countInvoiceToCheck (samo uz pravo izmene)
     │   └─ Pregled predračuna    countAvansAlarm
     └─ Ulazne fakture            = Provera SEF + Fakture za unos
         ├─ Provera SEF           ulazneZaMene  (direktor/eskaliran: sve što čeka
         │                                       odluku; ostali: dodeljeno meni)
         └─ Fakture za unos       ulazneZaUnos  (svi u firmi)

   Zbirovi se računaju OVDE, na jednom mestu, da meni, tab i podtab ne mogu da
   se raziđu — svaki nivo je zbir nivoa ispod. */

export const izlazneBadge = ({ countInvoiceToCheck, countAvansAlarm }, smeIzmenu) =>
    (smeIzmenu ? (countInvoiceToCheck || 0) : 0) + (countAvansAlarm || 0);

export const ulazneBadge = ({ ulazneZaMene, ulazneZaUnos }) =>
    (ulazneZaMene || 0) + (ulazneZaUnos || 0);

export const faktureBadge = (stanje, smeIzmenu) =>
    izlazneBadge(stanje, smeIzmenu) + ulazneBadge(stanje);

export const badgeTekst = (n) => (n > 99 ? '99+' : n);

/* Ulazni brojevi sa servera (sef.menadzerUlazniDokument GET_BADGE). */
export const osveziUlazneBadge = (token, dispatch) => {
    if (!token) return Promise.resolve();
    return fetch(process.env.REACT_APP_BACKEND_URL + '/sef/UlazniBadge', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({}),
    })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
            if (!d) return;
            dispatch({ type: 'ULAZNE_ZA_MENE_SET', value: d.broj || 0 });
            dispatch({ type: 'ULAZNE_ZA_UNOS_SET', value: d.zaUnos || 0 });
        })
        .catch(() => {});
};
